module.exports = __webpack_public_path__ + "img/oaknest-10.4a7de792.jpeg";